<div class='Home_testimonials'>
  <div class='Home_testimonials_wrapper container py-5'>
    <h2><span>Testimonials</span></h2>
    <mdb-carousel [animation]="'slide'">
      <mdb-carousel-item>
        <p>
          “Thanks for your help Retreva. I've been after this account for 8
          years and they bought three areas from me today! I know now, it also
          works great on helping bring back old accounts that cancelled.”
        </p>
      </mdb-carousel-item>
      <mdb-carousel-item>
        <p>
          “I can’t say enough good things about Retreva. I have tried many
          prospecting tools over my last 20 years in sales and C2S is as good as
          it gets! The more you put into it, the more you will benefit in the
          long run. The bottom line, you will see a good return on your
          investment, how good, is completely up to you.”
        </p>
      </mdb-carousel-item>
      <mdb-carousel-item>
        <p>
          “Retreva is the best tool I have ever used. I have not picked up
          the phone to cold call in over 3 years (not exaggerating). You will
          get out of it everything that you put in to it and it is super simple.
          Put in an email address and name, and the rest is all automatic.”
        </p>
      </mdb-carousel-item>
      <mdb-carousel-item>
        <p>
          “I follow up, I give a call,I shoot an email and get no response at
          all. I try again keeping my fingers crossed, Praying the response
          comes soon before it gets lost. Why, why, why I cry...I need a sale, I
          pray again to no avail. The world is changing, so I might as
          well,Thank God, Thank God for Retreva!!”
        </p>
      </mdb-carousel-item>
      <mdb-carousel-item>
        <p>
          “You have taken what I used to do manually and made a miracle happen!”
        </p>
      </mdb-carousel-item>
      <mdb-carousel-item>
        <p>
          “Retreva is really working for me. The simplicity of the message
          and the cycling of emails have helped me penetrate prospects and
          suspects. By using Retreva I have been able to connect with over
          200 companies in two months. I am sticking with Retreva.”
        </p>
      </mdb-carousel-item>
      <mdb-carousel-item>
        <p>
          “I love Retreva. It’s literally getting me appointment after
          appointment.”
        </p>
      </mdb-carousel-item>
      <mdb-carousel-item>
        <p>
          “I am so excited to tell you that I just closed my first deal as a
          result of Retreva! (And it was a good one!) I have another
          appointment tomorrow morning and just got another phone call as a
          result!! All within 24 hours!!”
        </p>
      </mdb-carousel-item>
      <mdb-carousel-item>
        <p>“Everyday your product makes my day”</p>
      </mdb-carousel-item>
      <mdb-carousel-item>
        <p>
          “This is the best sales tool ever!! It makes prospecting so easy!!!”
        </p>
      </mdb-carousel-item>
      <mdb-carousel-item>
        <p>
          “I love the Retreva program. It’s like I’m paying someone to cold
          call for me. Cold calling and making that first point of contact is
          half the battle. Retreva does it for me.”
        </p>
      </mdb-carousel-item>
    </mdb-carousel>
  </div>
</div>
